// extracted by mini-css-extract-plugin
export default {"editorBlock__drag":"styles_editorBlock__drag__wzAm4","editorBlock__dragIcon":"styles_editorBlock__dragIcon__Caidk"};